export const masterDBIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-database"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <ellipse cx="12" cy="6" rx="8" ry="3"></ellipse>
    <path d="M4 6v6a8 3 0 0 0 16 0v-6"></path>
    <path d="M4 12v6a8 3 0 0 0 16 0v-6"></path>
  </svg>
);

export const inventoryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"></polyline>
    <line x1="12" y1="12" x2="20" y2="7.5"></line>
    <line x1="12" y1="12" x2="12" y2="21"></line>
    <line x1="12" y1="12" x2="4" y2="7.5"></line>
    <line x1="16" y1="5.25" x2="8" y2="9.75"></line>
  </svg>
);

export const creditCollectionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <rect x="3" y="5" width="18" height="14" rx="3"></rect>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <line x1="7" y1="15" x2="7.01" y2="15"></line>
    <line x1="11" y1="15" x2="13" y2="15"></line>
  </svg>
);

export const accountingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-file-spreadsheet"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
    <path d="M8 11h8v7h-8z"></path>
    <path d="M8 15h8"></path>
    <path d="M11 11v7"></path>
  </svg>
);

export const SlBuilderData =
  JSON.parse(localStorage.getItem('sl_builders')) ?? [];
export const treasuryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-treasury"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 10l9 -6l9 6"></path>
    <path d="M4 10h16v10h-16z"></path>
    <path d="M6 10v10"></path>
    <path d="M10 10v10"></path>
    <path d="M14 10v10"></path>
    <path d="M18 10v10"></path>
    <circle cx="12" cy="14" r="2"></circle>
    <path d="M12 12v-2"></path>
    <path d="M12 16v2"></path>
  </svg>
);
